import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aaa-management',
  templateUrl: './aaa-management.component.html',
  styleUrls: ['./aaa-management.component.scss']
})
export class AAAManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
